
export * from '../../frontend-js-node-shims/__liferay__/exports/process.js';
